/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CountByMediaType,
    CountByMediaTypeFromJSON,
    CountByMediaTypeFromJSONTyped,
    CountByMediaTypeToJSON,
} from './CountByMediaType';
import {
    GetAutoMediaListMediaOutletCountByTypeResponseAllOf,
    GetAutoMediaListMediaOutletCountByTypeResponseAllOfFromJSON,
    GetAutoMediaListMediaOutletCountByTypeResponseAllOfFromJSONTyped,
    GetAutoMediaListMediaOutletCountByTypeResponseAllOfToJSON,
} from './GetAutoMediaListMediaOutletCountByTypeResponseAllOf';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';

/**
 * 
 * @export
 * @interface GetAutoMediaListMediaOutletCountByTypeResponse
 */
export interface GetAutoMediaListMediaOutletCountByTypeResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetAutoMediaListMediaOutletCountByTypeResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetAutoMediaListMediaOutletCountByTypeResponse
     */
    message: string;
    /**
     * 
     * @type {Array<CountByMediaType>}
     * @memberof GetAutoMediaListMediaOutletCountByTypeResponse
     */
    countByMediaTypes: Array<CountByMediaType>;
}

export function GetAutoMediaListMediaOutletCountByTypeResponseFromJSON(json: any): GetAutoMediaListMediaOutletCountByTypeResponse {
    return GetAutoMediaListMediaOutletCountByTypeResponseFromJSONTyped(json, false);
}

export function GetAutoMediaListMediaOutletCountByTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoMediaListMediaOutletCountByTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'countByMediaTypes': ((json['count_by_media_types'] as Array<any>).map(CountByMediaTypeFromJSON)),
    };
}

export function GetAutoMediaListMediaOutletCountByTypeResponseToJSON(value?: GetAutoMediaListMediaOutletCountByTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'count_by_media_types': ((value.countByMediaTypes as Array<any>).map(CountByMediaTypeToJSON)),
    };
}

